
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI2(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('div', { 'className': 'grid__item large--one-quarter medium--one-half small--one-half shown-on-scroll animated fadeIn' }, _createElement('product-card', {
                    'data-product-id': this.id,
                    'data-product-url': this.url,
                    'data-grid-count-desktop': '4',
                    'data-grid-count-mobile': '2',
                    'class': 'grid-view-item text-align--left'
                }, _createElement('div', {}, _createElement('div', { 'className': 'grid-view-item-image' }, _createElement('a', {
                    'href': this.url,
                    'title': this.removeHTML(this.title),
                    'className': 'grid__image grid__image__match',
                    'tabIndex': '-1'
                }, _createElement('div', { 'className': 'aspect-ratio aspect-ratio--square' }, _createElement('div', { 'className': 'responsive-image-wrapper' }, _createElement('img', {
                    'className': 'theme-img block-radius js',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                })), this.image2 ? _createElement('div', {
                    'className': 'responsive-image-wrapper product-card__image product-card__image--secondary',
                    'key': '771'
                }, _createElement('img', {
                    'className': 'theme-img block-radius js',
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2')
                })) : null)), _createElement('div', { 'className': 'product-card-image--bottom-wrapper' })), _createElement('div', { 'className': 'product-grid--title product-grid--title-font-body' }, _createElement('a', mergeProps({
                    'className': 'text-truncate--line',
                    'href': this.url
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('div', { 'className': 'product-grid--price product-grid--price-font-body' }, _createElement('a', {
                    'href': this.url,
                    'data-product-id': this.id,
                    'tabIndex': '-1'
                }, this.on_sale ? _createElement('div', {
                    'className': 'product-price--sale',
                    'key': '1610'
                }, _createElement('span', { 'className': 'money price-line-through price--sale-price' }, '\n              ', this.formatPrice(this.compare_at_price), '\n            '), _createElement('span', { 'className': 'money price--regular-price' }, this.price_varies ? _createElement('span', { 'key': '1879' }, _translate(`price_from`), ' ') : null, '\n              ', this.formatPrice(this.min_price || this.price), '\n            ')) : null, !this.on_sale ? _createElement('div', {
                    'className': 'product-price--regular',
                    'key': '2057'
                }, _createElement('span', { 'className': 'money price--regular-price' }, this.price_varies ? _createElement('span', { 'key': '2184' }, _translate(`price_from`), ' ') : null, '\n              ', this.formatPrice(this.min_price || this.price), '\n            ')) : null, this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'product-price--regular',
                    'key': '2362'
                }, '\n            ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n          ') : null)), _createElement('div', { 'className': 'product-grid--rating' }, [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '26580'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI2.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null])), _createElement('div', { 'className': 'product-grid--footer' }, _createElement('div', {
                    'data-product-added': 'Harley-Davidson\xAE Boys Backpack added to the cart',
                    'className': 'quick-add-wrapper quick-shop--block is-singular text-link-animated'
                }, _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'id': this.id,
                    'accept-charset': 'UTF-8',
                    'className': 'shopify-product-form',
                    'encType': 'multipart/form-data'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'form_type',
                    'value': 'product'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'utf8',
                    'value': '\u2713'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'sections',
                    'value': 'cart-drawer'
                }), this.variant_ids.length > 1 ? [_createElement('a', {
                        'className': 'btn--underlined quick-add-button quick-add-button-desktop',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '36331'
                    }, '\n              ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n            ')] : null, this.variant_ids.length === 1 ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '39691'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '39693'
                    }),
                    this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '39695'
                    }) : null,
                    _createElement('button', {
                        'className': 'btn--underlined quick-add-button quick-add-button-desktop',
                        'type': 'submit',
                        'data-form-id': this.id,
                        'disabled': this.out_of_stock,
                        'tabIndex': '0',
                        'key': '39697'
                    }, this.out_of_stock ? [_translate(`product_out_of_stock`)] : null, !this.out_of_stock ? [
                        _translate(`product_add_to_cart`),
                        this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : ''
                    ] : null),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'product-id',
                        'value': this.id,
                        'key': '39699'
                    })
                ] : null)))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []